import React from "react";

import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";

import { P } from "../../atoms/Texts";
import { DarkFormField, DarkSelectInput } from "../../atoms/Inputs";
import { PrimaryButton } from "../../atoms/Buttons";

export const AddTeamMemberForm = ({ addMember, loading }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const submitForm = (data) => {
    addMember(data);
  };

  return (
    <div className="w-full">
      <div className="w-full mx-auto">
        <form onSubmit={handleSubmit(submitForm)}>
          <div>
            <DarkFormField
              type="text"
              id="relationship"
              name="relationship"
              color="#F8F6FE"
              className="py-1 px-2"
              label="Relationship to organization"
              placeholder="CEO"
              defaultValue={""}
              iconBeforeClass=""
              inputClassName="-ml-3"
              {...register("relationship", {
                required: "Enter relationship to organization",
              })}
            />
            <ErrorMessage
              errors={errors}
              name="relationship"
              as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
            >
              {({ messages }) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <P key={type}>{message}</P>
                ))
              }
            </ErrorMessage>
          </div>

          <div>
            <DarkSelectInput
              type="select"
              id="role"
              name="role"
              className="py-1 px-2"
              label="User Level"
              defaultValue=""
              iconBeforeClass=""
              inputClassName="-ml-3"
              {...register("role", {
                required: "Select role for member",
              })}
            >
              <option value="" disabled>
                --Set role--
              </option>
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="reader">Reader</option>
            </DarkSelectInput>
            <ErrorMessage
              errors={errors}
              name="role"
              as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
            >
              {({ messages }) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <P key={type}>{message}</P>
                ))
              }
            </ErrorMessage>
          </div>

          <div className="mb-10 mt-8 mx-auto flex gap-5">
            <div className="w-full">
              <PrimaryButton disabled={loading} className="w-full">
                {loading ? "Updating" : "Send Invite"}
              </PrimaryButton>
              {/* <PrimaryButton>Save changes</PrimaryButton> */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTeamMemberForm;
